var _g, _text, _text2;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgCairnHorizontal(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 560 150",
    role: "img",
    "aria-labelledby": titleId,
    ref: svgRef
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId || "cairn-logo-title"
  }, "Cairn Pet Health") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId || "cairn-logo-title"
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(8 8) scale(.90)",
    fill: "#4F6473"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 21 97 C 36 103, 68 103, 93 100 C 102 98, 107 93, 106 88 C 104 84, 85 84, 64 84 C 46 84, 27 86, 22 90 C 19 93, 19 96, 21 97 Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 34 79 C 46 82, 70 82, 88 80 C 97 77, 101 73, 100 68 C 97 64, 80 63, 63 64 C 48 64, 36 65, 33 70 C 30 73, 31 77, 34 79 Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 45 60 C 54 62, 67 62, 80 59 C 87 57, 90 52, 87 48 C 84 46, 72 46, 62 46 C 52 46, 43 47, 40 53 C 38 56, 40 58, 45 60 Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 53 43 C 60 44, 69 44, 78 42 C 82 40, 84 37, 81 34 C 78 32, 70 32, 64 32 C 58 32, 51 33, 49 37 C 47 40, 49 42, 53 43 Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 52 28 C 57 30, 65 30, 70 28 C 73 26, 73 22, 70 20 C 67 18, 61 18, 56 20 C 52 22, 50 25, 52 28 Z"
  }))), _text || (_text = /*#__PURE__*/React.createElement("text", {
    x: 148,
    y: 72,
    fontFamily: "Avenir Next, Avenir, Inter, Arial, sans-serif",
    fontSize: 60,
    letterSpacing: 4,
    fill: "#4F6473"
  }, "CAIRN")), _text2 || (_text2 = /*#__PURE__*/React.createElement("text", {
    x: 151,
    y: 103,
    fontFamily: "Avenir Next, Avenir, Inter, Arial, sans-serif",
    fontSize: 18,
    letterSpacing: 5,
    fill: "#7A8F6B"
  }, "PET HEALTH")));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCairnHorizontal);
export default __webpack_public_path__ + "static/media/cairn-horizontal.4a02ef44fce8867a66c85071ebecd396.svg";
export { ForwardRef as ReactComponent };